import en from './en.json';

type Messages = typeof en;

const messages: Messages = en;

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function $_(path: string, replacements?: Record<string, string | number>): string {
  const parts = path.split('.');
  let cur: any = messages;

  for (const p of parts) {
    if (cur == null) {
      return path;
    }
    cur = cur[p];
  }

  if (typeof cur !== 'string') {
    return path;
  }

  let message = cur;

  if (replacements) {
    for (const [key, value] of Object.entries(replacements)) {
      const pattern = new RegExp(`{{\\s*${escapeRegExp(key)}\\s*}}`, 'g');
      message = message.replace(pattern, String(value));
    }
  }

  return message;
}

export type { Messages };
